import { gql } from '@apollo/client';

export const REMOVE_ACCESS_TOKEN_MUTATION = gql`
  mutation RemoveAccessTokenMutation($id: String!) {
    removeAccessToken(id: $id) {
      ... on RemoveAccessTokenSuccess {
        result
      }
      ... on ValidationError {
        errors {
          error
          path
        }
      }
    }
  }
`;
